import { PageConfigs } from "configs/globalInterfaces";
import { CONFIGS as ADMINS_CONFIGS } from "./Admins/configs";
import { CONFIGS as PROJECT_CONFIG } from "./Projects/configs";
// import { CONFIGS as DASHBOARD_CONFIGS } from "./Dashboard/configs";
import { CONFIGS as LANGUAGES_CONFIGS } from "./Languages/configs";
import { CONFIGS as CONTACT_US_CONFIGS } from "./ContactUs/configs";
import { CONFIGS as PROJECT_CATEGORIES_CONFIG } from "./ProjectCategories/configs";
import { CONFIGS as   BRANDS_CONFIG } from "./Brands/configs";
import { CONFIGS as   FAQS_CONFIG } from "./Faqs/configs";
import { CONFIGS as   BLOGS_CONFIG } from "./Blogs/configs";
import { CONFIGS as   BLOG_CATEGORIES_CONFIG } from "./BlogCategories/configs";
interface PagesConfig {
  [key: string]: PageConfigs;
}

export const PAGES_CONFIG: PagesConfig = {
  admins: ADMINS_CONFIGS,
  brands: BRANDS_CONFIG,
  faqs: FAQS_CONFIG,
  blogs: BLOGS_CONFIG,
  projects: PROJECT_CONFIG,
  projectCategories: PROJECT_CATEGORIES_CONFIG,
  blogCategories: BLOG_CATEGORIES_CONFIG,
  contactUs: CONTACT_US_CONFIGS,
  languages: LANGUAGES_CONFIGS,
};
